import type { ResultsReduxState } from "@app/types/results-redux-types";

export const getTripsSegments = (state: ResultsReduxState) =>
  state.trips_segments;
